import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ICustomer } from "redux/reducers/models/customer";

export type CustomerMembership = {
  client_id: number;
  customer: ICustomer;
  customer_id: number;
  expiry: Date | null;
  home_facility_id: number | null;
  home_facility_long_name: string | null;
  id: number;
  suspension_start_date: string;
  suspension_end_date: string;
  membership_id: number;
  membership_number: string;
  membership_subtitle: string;
  membership_title: string;
  membership_type: "multi-course" | "single-course";
  notes: string | null;
  order_id: number;
  order_name: string;
  season: string | null;
  status: "active" | "expired" | "disabled";
  status_readable: "Active" | "Expired" | "Disabled";
};

export interface IGetCustomerMemberships {
  id: number;
  search: string;
  customer_id: number;
  home_facility_id: number;
  limit: number;
  offset: number;
  parent_membership?: boolean;
}

//GET Memberships
export async function GetCustomerMemberships(
  params: Partial<IGetCustomerMemberships>,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/membership"), params, useGlobalLoader, token);
}

export async function PostCustomerMembership(
  params: { customer_id: number; membership_id: number },
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/membership"), params, useGlobalLoader);
}

//DISABLE MEMBERSHIP

export async function DisableMembership(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/membership/disable"), params, useGlobalLoader);
}

export interface IEnableMembershipParams {
  membership_id: number;
}
export async function EnableMembership(params: IEnableMembershipParams, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/membership/enable"), params, useGlobalLoader);
}

//DELETE MEMBERSHIP
export async function DeleteMembership(params: any, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/customer/membership"), params, useGlobalLoader);
}

// Move Membership
export async function MoveMembership(
  params: { customer_membership_id: number; new_customer_id: number },
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/membership/move"), params, useGlobalLoader);
}

//Print Membership
export async function PrintMembership(params: { id: number }, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/membership/print"), params, useGlobalLoader);
}

//Email Membership
export async function EmailMembership(params: { id: number }, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/membership/email"), params, useGlobalLoader);
}

export async function PostSuspendMembership(
  params: {
    membership_id: number;
    start_date: string;
    end_date: string;
    suspension_reason: string;
    indefinite_suspension: boolean;
  },
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/membership/suspend"), params, useGlobalLoader);
}

export async function PutUnsuspendMembership(params: { membership_id: number }, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/membership/unsuspend"), params, useGlobalLoader);
}


interface IEditExpiryDateParams {
  membership_id: number;
  expiry: string;
}
export async function PutEditExpiryDate(params: IEditExpiryDateParams, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/membership/update-expiry-date"), params, useGlobalLoader);
}
